<div class="w-full flex flex-column align-items-center gap-2">
  <p-tabView [(activeIndex)]="activeTab" class="no-border">
    <p-tabPanel header="Pickup">
      <ng-container *ngIf="activeTab === 0">
        <p-calendar
          [inline]="true"
          [(ngModel)]="pickupDateTime"
          (ngModelChange)="onPickupChange($event)"
          [showTime]="true"
        >
        </p-calendar>
      </ng-container>
    </p-tabPanel>

    <p-tabPanel header="Dropoff">
      <ng-container *ngIf="activeTab === 1">
        <p-calendar
          [inline]="true"
          [(ngModel)]="dropoffDateTime"
          (ngModelChange)="onDropoffChange($event)"
          [showTime]="true"
        >
        </p-calendar>
      </ng-container>
    </p-tabPanel>
  </p-tabView>

  <span class="font-bold mb-1">Driver Schedule becomes:</span>
  <div
    class="flex flex-wrap align-items-center"
    pTooltip="Earliest and latest pickup/dropoff times from driver schedule."
  >
    {{ pickupDateTime | datex : 'ddd Do MMM HH:mm' }} -
    {{ addHours(pickupDateTime, 1) | datex : 'HH:mm' }}
    <i class="fa fa-arrow-right mx-2 text-gray-600"></i>
    {{ dropoffDateTime | datex : 'ddd Do MMM HH:mm' }} -
    {{ addHours(dropoffDateTime, 1) | datex : 'HH:mm' }}
  </div>

  <div *ngIf="isOutsideCustomerWindow">
    <app-warning-container warningTitle="Outside customer window">
      <span> The selected driver schedule falls outside of the customer window. </span>
    </app-warning-container>
  </div>
</div>
